<template>
  <d-modal size="lg" @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('container.searchForProductInContainers') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form v-if="!loadingInProgress && !resultsDisplay">
        <validation-observer ref="container-search-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('purchase.numberOfPiecesNeeded') }}:
            </label>

            <validation-provider
              rules="required"
              name="quantity"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="number"
                :min="1"
                :step="1"
                v-model="quantity" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>

      <div
        v-if="loadingInProgress"
        class="text-center">
        {{ $t('container.containerSearchInProgress') }}&hellip;
      </div>

      <table
        v-if="!loadingInProgress && resultsDisplay && foundedContainers.length"
        class="table">
        <thead>
          <th style="width: 35%;">{{ $t('ui.name') }}</th>
          <th style="width: 30%;">{{ $t('order.delivery') }}</th>
          <th style="width: 35%;">{{ $t('purchase.bookIt') }}</th>
        </thead>
        <tbody>
          <tr
            v-for="(container, index) of foundedContainers"
            :key="'container-results-' + index">
            <td>
              {{ container.number }}

              <p
                v-if="!isEditMode"
                class="mt-0 mb-0">
                <small class="text-danger">
                  {{ $t('container.saveOrderToBeAbleToBook') }}
                </small>
              </p>
            </td>

            <td>
              {{ container.date }}
            </td>

            <td>
              <d-button
                v-if="!isOffer"
                type="success"
                @click.prevent="makeReservation(container.id, container.quantity_available)"
                class="w-100 text-center pl-1 pr-1"
                :disabled="!isEditMode">
                {{ $t('purchase.bookIt') }} {{ quantity > container.quantity_available ? container.quantity_available : quantity }} {{ $t('ui.piecesAbbr') }}
              </d-button>

              <p class="text-center mb-0">
                <small>
                  {{ $t('purchase.available') }}: <strong class="text-success">{{ container.quantity_available }} {{ $t('ui.piecesAbbr') }}</strong>
                </small>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <d-alert
        v-if="!loadingInProgress && resultsDisplay && !foundedContainers.length"
        show>
        {{ $t('container.noContainersWithSufficientProductQuantityFound') }}
      </d-alert>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        v-if="!loadingInProgress && !resultsDisplay"
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('ui.search') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'container-search-popup',
  props: [
    'productID',
    'orderProductID',
    'missingAmount',
    'usedContainers',
    'isOffer'
  ],
  computed: {
    isEditMode () {
      return !!this.$route.params.id;
    }
  },
  data () {
    return {
      quantity: 1,
      foundedContainers: [],
      loadingInProgress: false,
      resultsDisplay: false
    };
  },
  mounted () {
    this.quantity = this.missingAmount;

    if (this.quantity < 0) {
      this.quantity = 0;
    }
  },
  methods: {
    handleClose () {
      this.$bus.$emit('container-search-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['container-search-form'], this.searchContainers);
    },
    searchContainers () {
      this.loadingInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/products/containers/search',
        formData: {
          with: ['orderProductContainers'],
          product_id: this.productID,
          order_product_id: this.orderProductID || 0,
          quantity: parseInt(this.quantity, 10)
        },
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('ui.actionFailedTryAgain'),
        successAction: (response) => {
          this.foundedContainers = response.data;
          this.foundedContainers = this.foundedContainers.filter(container => this.usedContainers.indexOf(container.id) === -1);
          this.loadingInProgress = false;
          this.resultsDisplay = true;
        },
        failAction: () => {
          this.loadingInProgress = false;
        }
      });
    },
    cancel () {
      this.foundedContainers = [];
      this.resultsDisplay = false;
      this.quantity = 1;
      this.handleClose();
    },
    makeReservation (containerID, quantityAvailable) {
      let qty = this.quantity;

      if (quantityAvailable < this.quantity) {
        qty = quantityAvailable;
      }

      this.$bus.$emit(
        'order-product-container-reservation',
        this.productID,
        // eslint-disable-next-line
        isNaN(this.orderProductID) ? 0 : this.orderProductID,
        containerID,
        parseInt(qty, 10)
      );
      this.cancel();
    }
  }
}
</script>
